import { getGlobalCache, setGlobalCache } from '@/utils/search'
import type { TFunction } from 'react-i18next'

export const PAGINATION_CONFIG = {
  pageSizeOptions: ['10', '25', '50', '100', '200', '500'],
  defaultPageSize: 50,
}

export const getTableDefaultConfig = (t: TFunction) => {
  const pagination = {
    showSizeChanger: true,
    pageSizeOptions: PAGINATION_CONFIG.pageSizeOptions,
    showTotal: (total) => `${t('common.pagination.showTotal', { total: total })}`,
    locale: {
      items_per_page: t('pagination.items_per_page'),
    },
  }

  return {
    scroll: { x: 1000 },
    pagination,
  }
}

export const savePageSizeToLS = ({ value }) => {
  setGlobalCache({ key: 'pageSize', value })
}

export const getPageSizeInfoFromLS = () => {
  return getGlobalCache({ key: 'pageSize' })
}
